import { useSelector } from 'react-redux';
import { selectChangeableItems, selectAllChangeableItems, selectOrganizationName, selectSelectedOrganizationId, selectOrganizations } from './changeableItemsSlice';

export const useChangeableItems = () => {
  return useSelector(selectChangeableItems);
};

export const useAllChangeableItems = () => {
  return useSelector(selectAllChangeableItems);
};

export const useOrganizationName = () => {
  return useSelector((state) => state.changeableItems.organizationName);
};

export const useSelectedOrganizationId = () => {
  return useSelector(selectSelectedOrganizationId);
};

export const useOrganizations = () => {
  return useSelector(selectOrganizations);
};

export const getLabelByKey = (changeableItems, itemKey) => {
  if (!changeableItems || !Array.isArray(changeableItems)) {
    return 'unknown header';
  }
  const item = changeableItems.find((item) => item.item_key === itemKey);
  return item ? item.item : 'unknown header';
};

export const getPluralLabelByKey = (changeableItems, itemKey) => {
  const label = getLabelByKey(changeableItems, itemKey);
  if (/s$/i.test(label)) return label;
  if (/[^aeiou]y$/i.test(label)) return `${label.slice(0, -1)}ies`;
  return `${label}s`;
};